<script setup>
import { onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import DialogModal from '@/components/Modals/DialogModal.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import { mixins } from '@/Mixins/mixin.js';

defineProps({ show: Boolean });
const emit = defineEmits(['close']);

const { locale } = useI18n();

const selectLang = ref('id');
const langs = [
  { value: 'id', label: 'Indonesia' },
  { value: 'en', label: 'English' },
];
watch(selectLang, () => {
  locale.value = selectLang.value;
  localStorage.setItem('lang', locale.value);
});

const selectColor = ref('light');
const colors = [
  { value: 'light', label: 'Terang' },
  { value: 'dark', label: 'Gelap' },
];
watch(selectColor, () => {
  mixins.changeDarkMode(selectColor.value === 'dark');
});

onMounted(() => {
  selectColor.value = mixins.defaultDarkModeCheck() ? 'dark' : 'light';
  selectLang.value = localStorage.getItem('lang') || 'id';
});
</script>

<template>
  <DialogModal :show="show" @close="emit('close')">
    <template #title>Pengaturan Aplikasi</template>
    <template #content>
      <div class="grid grid-cols-1 divide-y divide-gray-500">
        <div class="grid grid-cols-1 md:grid-cols-[1.5fr_1fr] md:gap-4 items-center py-2">
          <div>
            <h4>Bahasa</h4>
            <p class="text-sm">Pengantar Aplikasi (Tidak termasuk pertanyaan)</p>
          </div>
          <div>
            <FormSelect id="lang" v-model="selectLang" :options="langs" option-key="value" option-label="label" />
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-[1.5fr_1fr] md:gap-4 items-center py-2">
          <div>
            <h4>Mode Warna</h4>
            <p class="text-sm">Gelap/Terang</p>
          </div>
          <div>
            <FormSelect id="color" v-model="selectColor" :options="colors" option-key="value" option-label="label" />
          </div>
        </div>
      </div>
    </template>
  </DialogModal>
</template>

<style scoped></style>